<app-prompt-card
  [openModal]="openModal"
  title="Send a test message"
  [buttonText]="buttonText"
  closeText="Cancel"
  tone="default"
  (onClose)="closeModal()"
  (onButtonClick)="onHandleSubmit()"
  [loading]="isLoading"
  [actionDisabled]="!testContacts.length || !selectedCount"
>
  <div class="st">
    <p class="st__lead">
      Pick who gets the test. Each person gets this message from {{ senderId || "your sender ID" }}, exactly as
      your recipients will.
    </p>

    @if (testContacts.length) {
      <fieldset class="st__pick" [disabled]="isLoading">
        <legend class="st__legend">
          <span>Test contacts</span>
          @if (testContacts.length > 1) {
            <button type="button" class="bk-more st__all" (click)="toggleAll()">
              {{ allSelected ? "Clear all" : "Select all" }}
            </button>
          }
        </legend>
        <ul class="st__list">
          @for (contact of testContacts; track contact.id) {
            <li>
              <label class="st__row" [class.is-on]="isSelected(contact)">
                <input
                  type="checkbox"
                  class="st__check"
                  [checked]="isSelected(contact)"
                  (change)="toggle(contact)"
                />
                <span class="st__who">
                  <span class="st__name">{{ nameOf(contact) }}</span>
                  <span class="st__phone">{{ displayPhone(contact.primaryContactNumber) || "No phone number" }}</span>
                </span>
              </label>
            </li>
          }
        </ul>
      </fieldset>
    } @else {
      <!-- A new tab, so the message being written here is not lost. -->
      <p class="st__empty">
        No test contacts yet.
        <a class="st__link" routerLink="/organization/settings/test-contacts" target="_blank" rel="noopener">
          Add one in Settings<span class="bk-sr-only"> (opens in a new tab)</span>
        </a>, then open this again to send the test.
      </p>
    }

    @if (showFeedback) {
      @if (feedbackType === "success") {
        <p class="st__note" role="status">
          <span class="bk-sym st__ok" aria-hidden="true">check_circle</span>{{ feedbackMessage }}
        </p>
      } @else {
        <p class="bk-field__error st__error" role="alert">
          <span class="bk-sym" aria-hidden="true">error</span>{{ feedbackMessage }}
        </p>
      }
    }
  </div>
</app-prompt-card>
